/**
 * File: parentViewController.js
 * Project: educore
 * Created Date: 2018-12-05
 * Author: Jeevanantham Nagarathinam
 * -----
 * Last Modified: 2018-12-05
 * Modified By: Jeevanantham Nagarathinam
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class ParentViewController {
    // @ngInject
    constructor($state, $rootScope, $scope, $mdDialog, $stateParams, localStorageService, authService, profileCons) {

        let self = this;
        let selectedUserId = $stateParams.person_id
        let addedSessionsID = [];
        $scope.showSessionName = [];
        $scope.showCurriculumName = [];
        $scope.userMgt = {}
        $scope.firstLoad = true //flag to check the page is loaded first or not4 occurences
        $scope.relationType = 'none'; //to check the relation type(Father,Mother or Guardian)
        let module_privileges = localStorageService.get("feature_privileges")


        $scope.userAccess = {}
        let features = module_privileges;
        let userAccessJson = _.filter(features, function(feature) {
            return feature.module_state == "userEndorsement";
        });
        if (userAccessJson) {
            _.each(userAccessJson, function(feature) {
                let user_access = {};
                _.each(feature.privilege, function(privObj) {
                    user_access[privObj.name.toLowerCase()] = privObj.status
                })
                $scope.userAccess = user_access;
            })
        }


        self.myStudents = [];
        if (!selectedUserId) {
            $state.go('profileSetting');
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: Get endorsed child list
         **/
        let getChild = () => {
            $scope.rolePARENT = true;
            authService.callAPI(profileCons.API_PARENT_CHILD_DETAILS + localStorageService.get('school_id') + "/" + selectedUserId, "GET", {}, (response) => {
                console.log(response)
                if (response.result && response.result.data && response.result.data.details) {
                    $scope.childPersonArr = response.result.data.details
                    _.defer(function() {
                        $scope.$apply();
                    });
                }
            })
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: Gte session list
         **/
        let sessionDet = () => {
            authService.callAPI(profileCons.API_GET_SESSION + localStorageService.get('school_id'), "GET", {}, (response) => {
                console.log(response)
                if (response.result && response.result.data && response.result.data.details) {
                    $scope.sessionLst = response.result.data.details
                    _.defer(function() {
                        $scope.$apply();
                    });
                }
            })
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: Gte curriculum list
         **/
        let curriculumDet = (session_id) => {
            authService.callAPI(profileCons.API_GET_CURRICULUM + localStorageService.get('school_id') + "/" + session_id, "GET", {}, (response) => {
                console.log(response)
                if (response.result && response.result.data && response.result.data.details) {
                    $scope.curriculumLst = response.result.data.details
                    _.defer(function() {
                        $scope.$apply();
                    });
                }
            })
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: Get class list
         **/
        let classDet = (curriculum_id) => {
            authService.callAPI(profileCons.API_GET_ALL_CLASS + localStorageService.get('school_id') + "/" + $scope.userMgt.session_id + "/" + curriculum_id, "GET", {}, (response) => {
                console.log(response)
                if (response.result && response.result.data && response.result.data.details) {
                    $scope.clsLst = response.result.data.details
                    _.defer(function() {
                        $scope.$apply();
                    });
                }
            })
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: Gte batch list
         **/
        let batchDet = (class_id) => {
            authService.callAPI(profileCons.API_GET_BATCH + localStorageService.get('school_id') + "/" + $scope.userMgt.session_id + "/" + $scope.userMgt.curriculum_id + "/" + class_id,
                "GET", {}, (response) => {
                    console.log(response)
                    if (response.result && response.result.data && response.result.data.details) {
                        $scope.batchLst = response.result.data.details
                        _.defer(function() {
                            $scope.$apply();
                        });
                    }
                })
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: Get unassigned  chils list
         **/
        let studentDet = (batch_id) => {
            authService.callAPI(profileCons.API_GET_STUDENTS + localStorageService.get('school_id') + "/" + $scope.userMgt.session_id + "/" + $scope.userMgt.curriculum_id + "/" + $scope.userMgt.class_id + "/" + batch_id,
                "GET", {}, (response) => {
                    console.log(response)
                    if (response.result && response.result.data && response.result.data.details) {
                        $scope.studentLst = response.result.data.details
                        _.defer(function() {
                            $scope.$apply();
                        });
                    }
                })
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: To update child data
         **/
        let updateChild = (academic_obj, user_id) => {

            let parent_obj = {
                "email": undefined,
                "relation": academic_obj.relation,
                "mapped": true
            }

            let details_obj = {}
            if (academic_obj.relation === 'Father' || academic_obj.relation === 'Mother') {
                details_obj.spouse_name = academic_obj.spousename
            }
            if (academic_obj.relation === 'Guardian') {
                details_obj.father_name = academic_obj.fathername
                details_obj.mother_name = academic_obj.mothername
            }


            let obj = {
                'child_id': academic_obj.student_id,
                'id': user_id,
                'parent_obj': parent_obj,
                'details_obj': details_obj
            }

            authService.callAPI(profileCons.API_UPDATE_CHILD, "POST", obj, (response) => {
                if (response.result && response.result.status && response.result.status.code == 200) {
                    toastr.success("Updated successfully!")
                }

                $scope.firstLoad = false
                $scope.userMgt = {};
                getChild()
                $scope.showParentSaveBtn = false;
                $scope.curriculumLst = [];
                $scope.clsLst = [];
                $scope.batchLst = []
                $scope.studentLst = []
            })
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: To remove child
         **/
        let removeChild = (user_id, academic_obj) => {
            let obj = {
                child_id: academic_obj._id,
                id: user_id
            }
            authService.callAPI(profileCons.API_DELETE_CHILD, "POST", obj, (response) => {
                if (response.result && response.result.status && response.result.status.code == 200) {
                    getChild()
                    toastr.success("Deleted successfully!")
                }
            })
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: Intialization
         **/
        this.$onInit = () => {
            getChild()
            sessionDet()
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: call fn to load curriculum list
         **/
        $scope.getCuriculumLst = (session_id) => {
            curriculumDet(session_id)
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: call fn to load class list
         **/
        $scope.getClassLst = (curriculum_id) => {
            classDet(curriculum_id)
        }


        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: call fn to load batch list
         **/
        $scope.getBatchLst = (session_id) => {
            batchDet(session_id)
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: call fn to load unassigned child list
         **/
        $scope.getStudentLst = (curriculum_id) => {
            studentDet(curriculum_id)
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: To add child 
         **/
        $scope.saveChild = () => {
            $scope.userMgt.school_id = localStorageService.get('school_id')
            if (!$scope.userMgt.spousename) {
                toastr.error("Please enter spouse name !")
                return false;
            }
            if ($scope.userMgt.session_id !== undefined && $scope.userMgt.curriculum_id !== undefined && $scope.userMgt.class_id !== undefined && $scope.userMgt.batch_id !== undefined) {
                if ($scope.userMgt.student_id && $scope.userMgt.student_id.length > 0) {
                    updateChild($scope.userMgt, selectedUserId)
                } else {
                    toastr.error("Please select atleast one student")
                }
            } else {
                if ($scope.userMgt.session_id === undefined && $scope.userMgt.curriculum_id === undefined && $scope.userMgt.class_id === undefined && $scope.userMgt.batch_id === undefined) {
                    toastr.error("Please select all necessary fields")
                } else {
                    if ($scope.userMgt.session_id === undefined) {
                        toastr.error("Please select session")
                    }
                    if ($scope.userMgt.curriculum_id === undefined) {
                        toastr.error("Please select curriculum")
                    }
                    if ($scope.userMgt.class_id === undefined) {
                        toastr.error("Please select class")
                    }
                    if ($scope.userMgt.batch_id === undefined) {
                        toastr.error("Please select batch")
                    }
                }
            }
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: Get relation data
         **/
        $scope.getRelationBox = (studIds) => {
            if (studIds.length >= 1) {
                $scope.getRelationDrp = true;
                if ($scope.isChildExist) {
                    $scope.showParentSaveBtn = true;
                }
            }
        }



        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: Chanage handler to set relation
         **/
        $scope.getRelation = (rel) => {
            $scope.relationType = rel;
            $scope.showParentSaveBtn = true;
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: call fn to remove child
         **/
        $scope.deleteChild = (child) => {
            var confirm = $mdDialog.confirm()
                .title('')
                .textContent('Are you sure to remove ?')
                .targetEvent(event)
                .ok('Yes')
                .cancel('No');
            $mdDialog.show(confirm).then(function() {
                removeChild(selectedUserId, child)
            }, function() {});
        }


    }
}

export default ParentViewController;


// WEBPACK FOOTER //
// ./src/app/profileSetting/controllers/parentViewController.js